import React from 'react';
export function EmailUnreadIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3v-7a1 1 0 10-2 0v7a1 1 0 01-1 1H5a1 1 0 01-1-1v-6.613l7.051 2.35a3 3 0 001.897 0l5.368-1.788a1 1 0 10-.632-1.898l-5.368 1.79a1 1 0 01-.632 0L4 8.279V7a1 1 0 011-1h11a1 1 0 100-2H5z"
  }));
}